<script lang="ts" setup>
import type { ParagraphFindAContactPersonFragment } from '#build/graphql-operations';

defineProps<ParagraphFindAContactPersonFragment>()

const { options, isEditing } = defineBlokkli({
  bundle: 'find_a_contact_person',
  globalOptions: ['spacingTop', 'spacingBottom', 'backgroundColor'],
})

const paragraphClassList = computed(() => {

  const classList = []

  if (options.value.spacingTop) {
    classList.push(options.value.spacingTop)
  }

  if (options.value.spacingBottom) {
    classList.push(options.value.spacingBottom)
  }

  if (options.value.backgroundColor !== 'white') {
    classList.push(options.value.backgroundColor)
  }

  return classList
})
</script>

<template>
  <LocationSearch :paragraphClassList="paragraphClassList" :title="title" :subline="subline" :text="text" />
</template>